/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  AiStoryAudienceType,
  AiStoryGoalType,
  Goal,
} from 'Generated/graphql-types'

// THIS IS USED TO DETERMINE THE INITIAL STATE OF THE STORY AI DIALOG
export enum StoryVariants {
  STORY = 'STORY',
  GOALS = 'GOALS',
}

// THIS IS USED IF THE INITIAL STATE SHOULD PREFILL ANY DATA
export type VariantSpecificData = {
  // IF WE'RE GENERATING THE STORY DIRECTLY FROM A GOAL WE ALREADY HAVE THE GOALS ARRAY AND SHOULD PREFILL THE GOAL
  goal?: {
    goalArray?: Goal[]
    preSelectedGoal?: Goal
  }
}

interface sharedInput {
  purpose?: AiStoryGoalType
  audience?: AiStoryAudienceType
  additionalRequests: string
}

// POSSIBLE INPUTS FOR THE AI STORY DIALOG
export interface AiStoryInput extends sharedInput {
  impact: string
  importance: string
}

// POSSIBLE INPUTS FOR THE GOAL VARIATION OF THE AI STORY DIALOG
export interface AiGoalsStoryInput extends sharedInput {
  goal: number
}

// DATA TO SEND TO BACKEND FOR STORY CREATION
export type StoryInput = {
  aiInput: AiStoryInput | AiGoalsStoryInput
  storyVariant: StoryVariants
}
